import React from "react";
import { Progress, InfiniteScroll, dialog, Button } from "nq-component";
import BaseListPage from "../../../../../../base/BaseListPage";
import EnrolleesPresenter from "./EnrolleesPresenter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import CardView from "../../../../../../components/common/CardView";
import Search from "../../../../../../components/Search";
import Table from "../../../../../../components/Table";
import { createNotification } from "../../../../../../createNotification";

class Enrollees extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new EnrolleesPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "enrollees";
  }
  async componentDidMount() {
    this.presenter.init(this.props.training); // Pass the training prop
    const objects = await findObjectUseCase().execute("enrollees");
    console.log("OBJECTTSSSS", objects);
    this.setState({ training: objects });
    this.refetchData();
  }

  dialogClose() {
    dialog.close();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async confirmChanges(objects) {
    const query = {
      where: {
        id: objects.id,
      },
    };
    const approveTraining = await findObjectUseCase().execute(
      "enrollees",
      query
    );

    // console.log("approveTraining: ", approveTraining);
    // return;

    for (const training of approveTraining) {
      const { id, ...statTraining } = training;
      const enrolledData = { id, ...statTraining, stats: "Enrolled" };
      const attendees = await findObjectUseCase().execute("attendees");

      await deleteObjectUseCase().execute("enrollees", training.id);

      const matchingAttendee = attendees.find(
        (attendee) =>
          attendee.trainingID === training.trainingID &&
          attendee.empID === training.empID
      );

      if (matchingAttendee) {
        const updatedAttendee = { ...matchingAttendee, stats: "Enrolled" };
        await upsertUseCase().execute("attendees", updatedAttendee);
        console.log("Updated attendee:", updatedAttendee);
      } else {
        console.log(
          `No matching attendee found for trainingID: ${training.id} and empID: ${training.empID}`
        );
      }
      await upsertUseCase().execute("enroll_training", enrolledData);
      await upsertUseCase().execute("certificate_appearance", enrolledData);
    }

    this.dialogClose();
    this.showSuccess("Data successfully APPROVED!");

    const NOTIFICATION_MESSAGE =
      "Your erolled training Request has been Approved!";
    const NOTIFICATION_RECEIVER = [objects.empID];
    const NOTIFICATION_REDIRECT = "learning/training";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT
    );

    return this.refetchData();
  }

  async confirmChangesDis(objects) {
    const query = {
      where: {
        id: objects.id,
      },
    };
    const approveTraining = await findObjectUseCase().execute(
      "enrollees",
      query
    );

    for (const training of approveTraining) {
      await deleteObjectUseCase().execute("enrollees", training.id);
    }

    this.dialogClose();
    this.showSuccess("Data successfully DISAPPROVED!");

    const NOTIFICATION_MESSAGE =
      "Your enrolled training Request has been Disapproved!";
    const NOTIFICATION_RECEIVER = [objects.empID];
    const NOTIFICATION_REDIRECT = "training";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT
    );

    return this.refetchData();
  }

  handleApproved(objects) {
    console.log("dia", objects);
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Confirmation</h4>
            <hr />
            <p>Approve Enrollees?</p>
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Please click Continue to confirm.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-3 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.confirmChanges(objects)}
            >
              Continue
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  handleDisApproved(objects) {
    console.log("dia", objects);
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Confirmation</h4>
            <hr />
            <p>Disapprove Enrollees?</p>
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Please click Continue to confirm.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-3 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.confirmChangesDis(objects)}
            >
              Continue
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, current, limit } = this.state;
    console.dir(objects);

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "training" &&
        fields !== "stats"
    );
    if (!schema) return <Progress />;
    return (
      <>
        <div style={{ margin: "1rem 0" }}>
          <CardView style={{ borderRadius: 0 }}>
            <Search
              schemas={this.getSchemas()}
              onSubmit={this.searchSubmit.bind(this)}
              fields={schema.fields}
            />
          </CardView>
        </div>
        <div className="overflow-auto">
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-primary">Enrollees</h4>
                  {/* <h5>Training: {this.props.object.training}</h5> */}
                </div>
              </CardView>

              <Table
                progress={count > objects.length}
                refetch={this.refetchData.bind(this)}
                objectData={this.handleApproved.bind(this)}
                objectDataDis={this.handleDisApproved.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-check-lg"> Approve</i>,
                    actionType: "object",
                  },
                  {
                    label: <i className="bi bi-x"> Disapprove</i>,
                    actionType: "objectDis",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default Enrollees;
